import { Card, Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { DomainOrderResponseDto } from '@tiendanube/common';
import { useSupportChat } from 'App/components/SupportChatContext';
import useTranslationConfigurations from 'domains/Configurations/useTranslationConfigurations';
import errorImage from './img/no-disponible.png';

interface ErrorOrderCardProps {
  order: DomainOrderResponseDto;
}

export function ErrorOrderCard({ order }: Readonly<ErrorOrderCardProps>) {
  const t = useTranslationConfigurations('domains.orderDetails.errorOrder');
  const { openChatOnly } = useSupportChat();

  return (
    <Card>
      <Box padding="8">
        <InitialScreen paddingTop="none">
          <InitialScreen.Hero
            title={t('title', { domainName: order.domainName })}
            description={t('description')}
            image={<img src={errorImage} width="100%" alt={t('imageAlt')} />}
            actions={
              <Button onClick={openChatOnly} appearance="primary">
                {t('supportButton')}
              </Button>
            }
          />
        </InitialScreen>
      </Box>
    </Card>
  );
}
